'use client';

import { useLocale } from './useLocale';
import { useExchangeRate } from './useExchangeRate';
import { formatPrice, convertToEUR } from '@/lib/price';

/**
 * Returns a function that formats a SEK price for the current locale.
 * On .se → formats as SEK (e.g. "1 234 kr")
 * On .me → converts SEK→EUR then formats (e.g. "€112.50")
 */
export function usePriceFormatter(): (sekPrice: number) => string {
  const { currency, priceMarkup } = useLocale();
  const exchangeRate = useExchangeRate();
  const isEur = currency === 'EUR';

  return (sekPrice: number): string => {
    if (isEur) return formatPrice(convertToEUR(sekPrice, exchangeRate, priceMarkup), 'EUR');
    return formatPrice(sekPrice);
  };
}
